var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoading)?_c('div',{staticClass:"shared-page"},[(_vm.isExpired)?_c('expired-shared-page'):_c(_vm.componentsByType[_vm.shareType],{tag:"component"})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }